"use client";

import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

import { MDButton } from "@/components/atoms/MDButton";
import MDTypography from "@/components/atoms/MDTypography";
import useToast from "@/contexts/toast-context";
import { ServiceInterfaceMessages } from "@/messages/service-interface/service-interface.messages";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  message: string;
  messages: ServiceInterfaceMessages;
};

export function MessageDetailModal({ isOpen, onClose, message, messages }: Props) {
  const { showToast } = useToast();

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(message);
      showToast({ text: messages.copySuccess, type: "success" });
    } catch {
      showToast({ text: messages.copyError, type: "error" });
    }
  };

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{messages.messageDetailModalTitle}</DialogTitle>
      <DialogContent>
        <MDTypography variant="body2" sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
          {message}
        </MDTypography>
      </DialogContent>
      <DialogActions>
        <MDButton variant="gradient" color="light" onClick={onClose}>
          {messages.settingsCloseButton}
        </MDButton>
        <MDButton variant="gradient" color="dark" onClick={handleCopy}>
          {messages.copyButton}
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
